import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class ManageAccount extends HttpForm {
    slug;
    data = false;
    metrics = false;
    constructor(params) {
        super();
        this.slug = params.slug;
    }
    mount() {
        return Promise.all([
            this.showAccount(),
            this.accountMetrics()
        ]).then(() => this.setLoadingState(true));
    }
    showAccount() {
        const url = '/api/account/' + this.slug;
        return axios.get(url)
            .then((response) => {
            this.data = response.data.data;
        })
            .catch(e => this.setError(e));
    }
    accountMetrics() {
        const url = '/api/account/' + this.slug + '/metrics';
        return axios.get(url)
            .then((response) => {
            this.metrics = response.data.data;
        })
            .catch(e => this.setError(e));
    }
    synchroniseProducts() {
        const url = '/api/product/sync';
        return axios.post(url, {
            account: this.slug
        }).catch(e => this.setError(e));
    }
}
